'use client'

import Link from 'next/link'
import { useParams, useRouter } from 'next/navigation'

import '@/styles/components/_cityList.scss'

import { FaMapMarkerAlt } from 'react-icons/fa'

interface CityLink {
  name: string
  slug: string
}

interface CityListProps {
  locations: CityLink[]
  activeSlug: string
  onChange?: (slug: string) => void
}

export default function CityList({ locations, activeSlug, onChange }: CityListProps) {
  const params = useParams()
  const locale = params.locale as string
  const router = useRouter()

  const handleClick = (e: React.MouseEvent, slug: string) => {
    e.preventDefault()
    if (slug === activeSlug) return

    let href = slug ? `/${locale}/promotion/${slug}/` : `/${locale}/promotion/`

    // If clicking "All" (empty slug), mark user's intent to view all promotions with timestamp
    if (!slug) {
      const data = {
        value: 'true',
        timestamp: Date.now()
      }
      sessionStorage.setItem('user-wants-all-promotions', JSON.stringify(data))
    }

    router.push(href)

    if (onChange) onChange(slug)
  }
  return (
    <div className='city-list-container'>
      {locations.map((loc) => {
        let href = loc.slug ? `/${locale}/promotion/${loc.slug}` : `/${locale}/promotion`

        return (
          <a
            key={loc.slug || 'all'}
            href={href}
            className={`city-link ${activeSlug === loc.slug ? 'active' : ''}`}
            onClick={(e) => handleClick(e, loc.slug)}>
            <FaMapMarkerAlt className='branch-icon' />
            <span className='city-name'>{loc.name}</span>
          </a>
        )
      })}
    </div>
  )
}
